import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosInstance from '../services/api';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
    const [menuArr, setMenuArr] = useState([]);
    const [userDetails, setUserDetails] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    // const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //   setLoaderRef(setLoading);
    // }, [setLoading]);

    const checkAuthentication = () => {
        const token = localStorage.getItem("accessToken"); // Adjust based on your auth implementation
        return !!token;
    };
    const fetchData = async () => {
        if (menuArr.length > 0) return; // Avoid multiple calls
      //  setLoading(true); // Show loader before the API call
        try {
            const response = await axiosInstance.get('user/dynamic-menu');
            setMenuArr(response.data.data.menus.menus || []);
            setUserDetails(response.data.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
          //setLoading(false); // Hide loader after the API call
        }
    };

    useEffect(() => {
        if (checkAuthentication()) {
          setIsAuthenticated(true);
          fetchData();
        }
      }, []);
      useEffect(() => {
        // Trigger fetching menu data on authentication change
        if (isAuthenticated) {
          fetchData();
        } else {
          setMenuArr([]); // Clear menu if not authenticated
          setUserDetails('')
        }
      }, [isAuthenticated]);
    
      const updateAuthStatus = (status) => {
        setIsAuthenticated(status);
      };
    console.log(menuArr, userDetails,"userDetails", updateAuthStatus)
    return (
        <MenuContext.Provider value={{menuArr, userDetails , updateAuthStatus} }>
            {/* {loading && ( 
              <div className="loader-overlay">
                <div className="loader"></div>
              </div>
            )} */}
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => useContext(MenuContext);
